import NoteRegister from "../AdjustmentNotes/NoteRegister";
import "./creditDesign.css";
export default function AdjustmentCreditRegister() {
  return <NoteRegister credit />;
}
